import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useInvokeAction = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (request: Types.IInvokeActionRequestData): Promise<Types.IInvokeActionResponseData> => {
        const { data } = await send<Types.IInvokeActionRequestData, Types.IInvokeActionResponseData>({
            ID: 35668,
            description: 'Invoke Action',
            responses: [35669, 35670],
            errorLevel: 1,
            casino: casinoName,
            ...request
        });

        return data;
    }, [
        send,
        casinoName
    ]);
};
